import React from 'react'
import NextImage from 'next/image'
import { AnimatePresence, motion } from 'framer-motion'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

interface IConversationLandingOnboardingPartOneProps {
  onClick: () => void
}
const ConversationLandingOnboardingPartOne: React.FC<
  IConversationLandingOnboardingPartOneProps
> = ({ onClick }) => {
  return (
    <>
      <AnimatePresence>
        <motion.div
          className="flex items-center justify-center mx-auto space-x-0 max-w-7xl"
          animate={{
            y: [0, 0, 0],
            opacity: [0, 20, 100],
            scale: [1.1, 1, 1],
          }}
          transition={{
            ease: 'easeInOut',
            duration: 0.6,
            delay: 0.6,
          }}
          viewport={{ once: true }}
        >
          <Text>Halo, Saya</Text>&nbsp;
          <Text variant="action" className="!text-blue-50">
            Aru, Asisten Guru
          </Text>
        </motion.div>
      </AnimatePresence>
      <AnimatePresence>
        <motion.div
          className="bg-[url('/images/asisten-guru/bg-pattern.svg')] bg-no-repeat bg-center py-8 bg-cover"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{
            ease: 'easeInOut',
            duration: 0.3,
            delay: 1.2,
          }}
          viewport={{ once: true }}
        >
          <motion.div
            className="flex items-center justify-center mx-auto space-x-0 max-w-7xl lg:flex-row lg:space-x-10 2xl:space-x-20"
            animate={{
              y: [20, -5, -5, 0],
              opacity: [0, 100, 100],
              scale: [1.1, 1.1, 1],
            }}
            transition={{
              ease: 'easeInOut',
              duration: 0.6,
              delay: 1.2,
            }}
            viewport={{ once: true }}
          >
            <NextImage
              src="/images/asisten-guru/avatar-bordered.gif"
              width="220px"
              height="225px"
              placeholder="blur"
              blurDataURL="/images/asisten-guru/avatar-bordered-placeholder.png"
            />
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        <motion.div
          className="flex items-center justify-center mx-auto space-x-0 max-w-7xl lg:flex-row lg:space-x-10 2xl:space-x-20"
          initial={{ opacity: 0, y: '10%' }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeInOut', duration: 0.1, delay: 1.8 }}
          viewport={{ once: true }}
        >
          <Text variant="display-md">Asisten Guru adalah</Text>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        <motion.div
          className="flex items-center justify-center mx-auto space-x-0 max-w-7xl lg:flex-row lg:space-x-10 2xl:space-x-20"
          initial={{ opacity: 0, y: '10%' }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeInOut', duration: 0.1, delay: 1.9 }}
          viewport={{ once: true }}
        >
          <Text variant="display-md">Kecerdasan Buatan.</Text>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        <motion.div
          className="flex items-center justify-center mx-auto space-x-0 max-w-7xl lg:flex-row lg:space-x-10 2xl:space-x-20"
          initial={{ opacity: 0, y: '10%' }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeInOut', duration: 0.1, delay: 2 }}
          viewport={{ once: true }}
        >
          <Text variant="display-md">Aru bisa bantu jawab</Text>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        <motion.div
          className="flex items-center justify-center mx-auto space-x-0 max-w-7xl lg:flex-row lg:space-x-10 2xl:space-x-20"
          initial={{ opacity: 0, y: '10%' }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeInOut', duration: 0.1, delay: 2.1 }}
          viewport={{ once: true }}
        >
          <Text variant="display-md">pertanyaan apapun</Text>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        <motion.div
          className="flex items-center justify-center mx-auto space-x-0 max-w-7xl lg:flex-row lg:space-x-10 2xl:space-x-20"
          initial={{ opacity: 0, y: '10%' }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeInOut', duration: 0.1, delay: 2.2 }}
          viewport={{ once: true }}
        >
          <Text variant="display-md">tentang pendidikan.</Text>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        <motion.div
          className="max-w-xl mx-auto fixed bottom-0 left-0 right-0 p-4 space-y-4 bg-white shadow-[inset_0px_5px_3px_-3px_rgba(0,0,0,0.08)]"
          initial={{ opacity: 0, y: '10%' }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeInOut', duration: 0.6, delay: 2.8 }}
          viewport={{ once: true }}
        >
          <div className="flex items-end gap-x-3">
            <Button color="blue" size="lg" fullWidth onClick={onClick}>
              Selanjutnya
            </Button>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  )
}

export default ConversationLandingOnboardingPartOne
